import { MapPin, Clock, MessageCircle } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { useBooking } from "@/context/BookingContext";
import { IMAGES } from "@/data/content";
import { useContent } from "@/context/ContentContext";

export const Footer = () => {
  const { openTour, openCafe } = useBooking();
  const { content } = useContent();
  const contact = content.contact;

  return (
    <footer id="visit" data-testid="footer" className="bg-[#f4f1ea] px-6 pt-28 lg:px-10 lg:pt-40">
      <div className="mx-auto max-w-[1400px]">
        <Reveal>
          <div className="overline mb-6">Find us</div>
          <h2 className="max-w-3xl font-serif text-4xl font-medium leading-tight tracking-tight text-[#23281f] lg:text-7xl">
            Come, sit, <span className="italic text-[#ba5a45]">breathe.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-12 border-t border-[#ddd6c8] pt-14 lg:grid-cols-3">
          <div>
            <div className="mb-4 flex items-center gap-2 text-[#ba5a45]">
              <MapPin className="h-4 w-4" />
              <span className="overline">Location</span>
            </div>
            <p className="leading-relaxed text-[#5c6157]">
              {(contact.location || "").split("\n").map((line, i) => (
                <span key={i}>
                  {line}
                  <br />
                </span>
              ))}
            </p>
          </div>
          <div>
            <div className="mb-4 flex items-center gap-2 text-[#ba5a45]">
              <Clock className="h-4 w-4" />
              <span className="overline">Hours</span>
            </div>
            <p className="leading-relaxed text-[#5c6157]">
              {(contact.hours || "").split("\n").map((line, i) => (
                <span key={i}>
                  {line}
                  <br />
                </span>
              ))}
            </p>
          </div>
          <div>
            <div className="mb-4 flex items-center gap-2 text-[#ba5a45]">
              <MessageCircle className="h-4 w-4" />
              <span className="overline">Get in touch</span>
            </div>
            {contact.list ? (
  contact.list.map((item, index) => (
    <a 
      key={index}
      href={item.link}
      target="_blank"
      rel="noreferrer"
      className="hover:underline text-lg text-[#23281f] block mb-2"
    >
      <strong>{item.name}:</strong> {item.phone}
    </a>
  ))
) : (
  <a 
       href={`https://wa.me{contact.whatsapp}`}
    target="_blank"
    rel="noreferrer"
    className="hover:underline text-lg text-[#23281f]"
  >
    WhatsApp: {contact.phone_display || contact.whatsapp}
  </a>
)}

            <div className="mt-6 flex flex-wrap gap-3">
              <button
                onClick={() => openTour()}
                data-testid="footer-book-tour"
                className="rounded-none bg-[#ba5a45] px-6 py-3 text-xs font-semibold uppercase tracking-wider text-[#f6f3ec] transition-colors hover:bg-[#9c4633]"
              >
                Book an Experience
              </button>
              <button
                onClick={openCafe}
                data-testid="footer-reserve"
                className="rounded-none border border-[#c9bfa9] px-6 py-3 text-xs font-semibold uppercase tracking-wider text-[#23281f] transition-colors hover:border-[#23281f]"
              >
                Reserve a Table
              </button>
            </div>
          </div>
        </div>

        <div className="mt-24 flex flex-col items-center gap-3 border-t border-[#ddd6c8] py-8 sm:flex-row sm:justify-between">
          <span className="font-serif text-2xl text-[#23281f]">
            <img src={IMAGES.logo} alt="Aruha" className="h-12 w-auto" />
          </span>
          <p className="text-xs text-[#8a7a62]">
            © {new Date().getFullYear()} Aruha Trails · Dining in the heart of the wild ·{" "}
            <a href="/admin" className="hover:text-[#5c6157]" data-testid="footer-admin-link">Admin</a>
          </p>
        </div>
      </div>
    </footer>
  );
};
